import React from 'react';
import ScrollUpButton from 'react-scroll-up-button'; //Add this line Here
import styled from 'styled-components';

import { BaseBox } from 'src/kit';
import Icon from '@src/assets/svg/page-up-button.inline.svg';
import { CenteredFlex } from '../atoms';

export const ScrollUp = () => {
  return (
    <Wrapper>
      <ScrollUpButton ShowAtPosition={200}>
        <CenteredFlex width="40px" height="40px" borderRadius="50px">
          <BaseBox as={Icon} />
        </CenteredFlex>
      </ScrollUpButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  z-index: 100;
  position: fixed;
  bottom: 180px;
  right: 30px;

  .ScrollUpButton__Container {
    display: none;

    > div {
      cursor: pointer;
      background: rgb(79, 85, 104);
      opacity: 1;
      transition: opacity 0.25s ease-out;

      &:hover {
        opacity: 0.6;
      }
    }
  }

  .ScrollUpButton__Container.ScrollUpButton__Toggled {
    display: block;
  }
`;
